import React, { Component, PropTypes } from 'react';
import Translate from 'react-translate-component';
import { connect } from 'react-redux';
import RegisterView from '../register-view';
import RegisterWithEidView from '../register-with-eid-view';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from 'react-router';

class RegisterDetails extends Component {

  static propTypes = {
    // Redux state
    tab: PropTypes.string
  };

  constructor (props) {
    super(props);

    this.state = {
      show: 'BANKID'
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick (event) {
    const id = event.target.id;
    this.setState({
      show: id
    });
  }

  render () {
    let showContent;
    if (this.state.show === 'BANKID') {
      showContent = <RegisterWithEidView
        switchView={this.handleClick}
      />;
    } else {
      showContent = <RegisterView
        switchView={this.handleClick}
      />;
    };

    return (
      <div className='register-details'>
        <div className='register-top-section'>
          <div className='register-logo'>
            <object type="image/svg+xml"
              data={require('images/logos/logo-blue.svg')}
              alt='Frilans Finans-logotyp'>
              <img src={require('images/logos/logo-white.png')} alt="Frilans Finans-logotyp" />
            </object>
          </div>
          <div className='login-type-selection'>
            <Link to='/login'>
              <Translate
                className='register-type-selection-button'
                content='LOGIN'
              />
            </Link>
            <Translate
              id='BANKID'
              className='register-type-selection-button active'
              onClick={this.handleClick}
              content='CREATE_ACCOUNT'
            />
          </div>
        </div>
        <div className='register-bottom-section'>
          <div className='section-content'>
            <Translate className='login-title' content='CREATE_ACCOUNT' />
            {showContent}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    tab: state.router.locationBeforeTransitions.query.tab
  };
};

export default connect(mapStateToProps)(RegisterDetails);



/** WEBPACK FOOTER **
 ** ./src/views/register-view/tabs/register-details.js
 **/